import React from "react";

function Canvas_Shapes() {
  return (
    <div>
      <h1>Canvas_Shapes Component</h1>
      <p>This is the Canvas Shapes tutorial page content.</p>
    </div>
  );
}

export default Canvas_Shapes;
